import { useViewerMaybe } from "@/authentication/ViewerProvider"
import React, { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { signInPath } from "../org-admins-paths"

export const RequireUserSignedIn = () => {
  const navigate = useNavigate()
  const { viewer, loading } = useViewerMaybe()

  useEffect(() => {
    if (!(viewer || loading)) {
      navigate(signInPath.pattern)
    }
  }, [viewer, loading, navigate])

  if (viewer) {
    return <Outlet />
  }

  return null
}
